import { useState, useEffect } from 'react';
import getConfig from 'next/config';
import { useRouter } from 'next/router';
import { clearAllCookies } from '../../hooks/useCookie';
import { clearLocalStorage } from '../../hooks/useLocalStorage';
import EirActionModal from '../eir-action-modal/EirActionModal';
import fetchInfo from '../../../util/fetchModalData';

const { publicRuntimeConfig } = getConfig();

const sessionExpireModal = ({ confirmLogOut }) => {
  const router = useRouter();
  const [cmsCollectionData, setCmsCollectionData] = useState({});
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [load, setLoad] = useState(true);
  const handleOk = () => {
    window.localStorage.clear();
    clearLocalStorage();
    clearAllCookies();
    router.push(`${publicRuntimeConfig.NEXT_PUBLIC_OPENCMS}`);
    confirmLogOut.disable();
  };

  const getCmsData = async () => {
    try {
      const data = await fetchInfo({
        collectionType: 'eir-action-modals',
        modalID: 'eir-session-expiry',
      });

      if (Object?.keys(data).length !== 0) {
        setLoad(false);
        setCmsCollectionData(data);
      }
    } catch (error) {
      console.error('error', error);
    }
  };
  useEffect(() => {
    getCmsData();
  }, []);

  useEffect(() => {
    if (Object.keys(cmsCollectionData || {}).length !== 0) {
      setTitle(cmsCollectionData?.attributes?.title);
      setDescription(cmsCollectionData?.attributes?.firstHalfDescription);
    }
  }, [cmsCollectionData]);
  return (
    <EirActionModal
      id={cmsCollectionData?.attributes?.modalID}
      open={confirmLogOut.value}
      handleClose={confirmLogOut.disable}
      title={title}
      iconSrc=''
      description={description}
      cta={[
        {
          // text: 'Ok',
          text: cmsCollectionData?.attributes?.cta[0]?.name
            ? cmsCollectionData?.attributes?.cta[0]?.name
            : 'Ok',
          ariaLabel: cmsCollectionData?.attributes?.cta[0]?.ariaLabel
            ? cmsCollectionData?.attributes?.cta[0]?.ariaLabel
            : '',
          type: 'solid',
          action: () => handleOk(),
        },
      ]}
      disableCloseOnBackdropClick
      disableCloseOnEscapeKeyDown
      disablecta={false}
      load={load}
    />
  );
};
export default sessionExpireModal;
